<h1 mat-dialog-title>{{ 'moveSessionsToSubject.title' | translate }}</h1>

<mat-dialog-content class="modal-wide">

  <form *ngIf="!moveSummary; else summaryContent" [formGroup]="form" class="form-full-width">
    <label [id]="elementIds.projectLabel">{{ 'moveSessionsToSubject.labels.projectLabel' | translate }}</label>
    <mat-form-field appearance="outline">
      <mat-select formControlName="projectId" test-id="project-select"
        [placeholder]="'moveSessionsToSubject.labels.projectPlaceholder' | translate"
        [aria-labelledby]="elementIds.projectLabel">
        <mat-optgroup *ngFor="let group of groupedProjects$ | async" [label]="group.label">
          <mat-option *ngFor="let project of group.projects" [value]="project._id">{{ project.label }}</mat-option>
        </mat-optgroup>
      </mat-select>
    </mat-form-field>

    <ng-container *ngIf="!form.get('projectId').invalid">
      <mat-radio-group formControlName="existingOrNew">
        <mat-radio-button value="existing" test-id="mode-existing">{{ 'moveSessionsToSubject.labels.existingSubject' | translate }}</mat-radio-button>
        <mat-radio-button value="new" test-id="mode-new">{{ 'moveSessionsToSubject.labels.newSubject' | translate }}</mat-radio-button>
      </mat-radio-group>

      <ng-container *ngIf="form.get('existingOrNew').value === 'existing'">
        <label [id]="elementIds.existingSubjectLabel">{{ 'moveSessionsToSubject.labels.existingSubjectLabel' | translate }}</label>
        <mat-form-field appearance="outline">
          <input type="text" matInput formControlName="existingSubjectId" test-id="existing-session"
            [matAutocomplete]="subjectAutocomplete"
            [placeholder]="'moveSessionsToSubject.labels.existingSubjectPlaceholder' | translate"
            (blur)="blurSubjectLabel()"
            [attr.aria-labelledby]="elementIds.existingSubjectLabel">
          <mat-error *ngIf="form.get('existingSubjectId').hasError('required')">
            {{ 'moveSessionsToSubject.errors.subjectIdRequired' | translate }}
          </mat-error>
          <mat-error *ngIf="form.get('existingSubjectId').hasError('validSubjectId')">
            {{ 'moveSessionsToSubject.errors.subjectIdInvalid' | translate }}
          </mat-error>
          <mat-autocomplete #subjectAutocomplete="matAutocomplete" [displayWith]="displaySubjectLabel">
            <mat-option *ngFor="let subject of filteredSubjects$ | async" [value]="subject._id">
              {{ subject.label || subject._id }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </ng-container>

      <ng-container *ngIf="form.get('existingOrNew').value === 'new'">
        <label [id]="elementIds.newSubjectLabel">{{ 'moveSessionsToSubject.labels.newSubjectLabel' | translate }}</label>
        <mat-form-field appearance="outline">
          <input type="text" matInput formControlName="newSubjectLabel" test-id="new-session"
            [placeholder]="'moveSessionsToSubject.labels.newSubjectPlaceholder' | translate"
            [attr.aria-labelledby]="elementIds.newSubjectLabel">
          <mat-error>
            {{ 'moveSessionsToSubject.errors.subjectLabelLength' | translate }}
          </mat-error>
        </mat-form-field>
        <span *ngIf="newSubjectLabelExists$ | async">
          {{ 'moveSessionsToSubject.messages.subjectLabelExists' | translate }}
        </span>
      </ng-container>

      <p>{{ 'moveSessionsToSubject.messages.changeSubject' | translate }}</p>
    </ng-container>
  </form>

  <ng-template #summaryContent>
    <div class="move-summary">
      <div *ngIf="moveSummary.moved > 0" class="move-success">
        <mat-icon class="xs">check_circle</mat-icon>
        <span>{{ 'moveSessionsToSubject.messages.moveSuccess' | translate | interpolate:moveSummary.moved:moveSummary.total }}</span>
      </div>
      <div *ngIf="moveSummary.failed > 0" class="move-failed">
        <mat-icon class="xs">error_outline</mat-icon>
        <span>{{ 'moveSessionsToSubject.messages.moveFailure' | translate | interpolate:moveSummary.failed }}</span>
      </div>
    </div>
    <mat-table *ngIf="moveSummary.failed > 0" [dataSource]="moveSummary.failedSessions" test-id="move-session-errors">
      <ng-container matColumnDef="_id">
        <mat-header-cell *matHeaderCellDef>{{ 'common.labels.id' | translate }}</mat-header-cell>
        <mat-cell *matCellDef="let result">
          <mat-icon class="xs">error_outline</mat-icon>
          <span>{{ result._id }}</span>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="label">
        <mat-header-cell *matHeaderCellDef>{{ 'common.labels.label' | translate }}</mat-header-cell>
        <mat-cell *matCellDef="let result">{{ result.label }}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="error">
        <mat-header-cell *matHeaderCellDef>{{ 'common.labels.error' | translate }}</mat-header-cell>
        <mat-cell *matCellDef="let result">{{ result.error }}</mat-cell>
      </ng-container>
      <mat-header-row *matHeaderRowDef="['_id', 'label', 'error']"></mat-header-row>
      <mat-row *matRowDef="let snapshot; columns: ['_id', 'label', 'error']"></mat-row>
    </mat-table>
  </ng-template>

</mat-dialog-content>

<mat-dialog-actions align="end">
  <button *ngIf="moveSummary; else moveCancel" mat-stroked-button [mat-dialog-close]="moveSummary.moved > 0" test-id="dialog-close">
    {{ 'common.actions.close' | translate }}
  </button>
  <ng-template #moveCancel>
    <button mat-stroked-button [mat-dialog-close]="false" test-id="dialog-close">
      {{ 'common.actions.cancel' | translate }}
    </button>
    <button mat-flat-button color="primary" test-id="dialog-move"
      [disabled]="!form.valid || saving" (click)="moveSessions()">
      {{ 'common.actions.move' | translate }}
    </button>
  </ng-template>
</mat-dialog-actions>
